export default __webpack_public_path__ + "static/media/Y8.b9f9d243.jpg";